import { required } from '@vuelidate/validators';
import { validationI18n } from '@shared/i18n';

export const useSearchFormValidation = (messageRootPath: string) => {
  const { withI18nMessage } =
    validationI18n.model.useLocalizedValidators(messageRootPath);

  return {
    townFrom: {
      townToRequired: withI18nMessage(required),
    },
    countryTo: {
      countryToRequired: withI18nMessage(required),
    },
    arrDate: {
      from: {
        selectedDatesRequired: withI18nMessage(required),
      },
      to: {
        selectedDatesRequired: withI18nMessage(required),
      },
    },
    depDate: {
      from: {
        selectedDatesRequired: withI18nMessage(required),
      },
      to: {
        selectedDatesRequired: withI18nMessage(required),
      },
    },
  };
};
